module.exports = __webpack_public_path__ + "static/banner-7eb9faea5b609961dd9aa708eeffe313.png";